import { render } from "./moreWidth.vue?vue&type=template&id=473f76f6&scoped=true"
const script = {}

import "./moreWidth.vue?vue&type=style&index=0&id=473f76f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473f76f6"]])

export default __exports__